export const content = i18n => ({
  shippingMethod: i18n.t`Shipping method`,
  returnToCustomerInformation: i18n.t`Return to customer info`,
  continueToPayment: i18n.t`Continue to payment`,
  contact: i18n.t`Contact`,
  shipTo: i18n.t`Ship to`,
  change: i18n.t`Change`,
});
